module.exports = __webpack_public_path__ + "img/post-prev-1.fbf6dcc3.png";